<template>
  <div class="member-manage-section">
    <div class="search-bar">
      <a-input
        v-model="memberPageKeyword"
        placeholder="搜索会员"
        style="width: 300px"
      />
      <a-select
        v-model="selectedLevel"
        placeholder="选择会员等级"
        style="width: 200px; margin-left: 10px"
        allowClear
      >
        <a-select-option value="">全部等级</a-select-option>
        <a-select-option
          v-for="level in plusLevelList"
          :key="level.id"
          :value="level.id"
        >
          {{ level.levelName }}
        </a-select-option>
      </a-select>
      <a-button type="primary" @click="handleMemberPageSearch" style="margin-left: 10px">
        <a-icon type="search" />
        搜索
      </a-button>
    </div>
    <div class="action-bar">
      <a-button type="primary" @click="openAddMemberModal">
        <a-icon type="plus" />
        新增会员
      </a-button>
    </div>
    <a-table
      :columns="memberColumns"
      :data-source="memberList"
      :pagination="memberPagination"
      @change="handleMemberTableChange"
      :loading="memberLoading"
      rowKey="id"
    >
      <template slot="level" slot-scope="text">
        <a-tag :color="getMemberLevelColor(text)">{{ text || '普通会员' }}</a-tag>
      </template>
      <span slot="operation" slot-scope="text, record">
        <a @click="openBuyMemberModal(record)" style="margin-right: 10px">
          <a-icon type="shopping-cart" />购买会员
        </a>
        <a @click="openPlusOrderModal(record)" style="margin-right: 10px">
          <a-icon type="history" />购买记录
        </a>
        <a @click="openRechargeModal(record)">
          <a-icon type="wallet" />充值余额
        </a>
      </span>
    </a-table>

    <!-- 新增会员弹窗 -->
    <a-modal
      :visible="addMemberModalVisible"
      title="新增会员"
      @cancel="closeAddMemberModal"
      :maskClosable="false"
      :footer="null"
      width="600px"
    >
      <a-form-model
        ref="addMemberForm"
        :model="addMemberForm"
        :rules="addMemberRules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
      >
        <a-form-model-item label="手机号" prop="mobile">
          <a-input v-model="addMemberForm.mobile" placeholder="请输入手机号" />
        </a-form-model-item>
        <a-form-model-item label="昵称" prop="nickName">
          <a-input v-model="addMemberForm.nickName" placeholder="请输入昵称" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ offset: 5, span: 19 }">
          <a-space>
            <a-button type="primary" :loading="addMemberLoading" @click="handleAddMember">
              确定
            </a-button>
            <a-button @click="closeAddMemberModal">
              取消
            </a-button>
          </a-space>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 购买会员弹窗 -->
    <buy-member-modal
      :visible="buyMemberModalVisible"
      :member-data="currentBuyMember"
      @cancel="closeBuyMemberModal"
      @success="handleBuyMemberSuccess"
    />

    <!-- PLUS会员购买记录弹窗 -->
    <a-modal
      :visible="plusOrderModalVisible"
      title="PLUS会员购买记录"
      @cancel="closePlusOrderModal"
      :footer="null"
      width="800px"
    >
      <a-table
        :columns="plusOrderColumns"
        :data-source="plusOrderList"
        :pagination="false"
        :loading="plusOrderLoading"
        rowKey="id"
      >
      </a-table>
    </a-modal>

    <!-- 充值余额弹窗 -->
    <a-modal
      :visible="rechargeModalVisible"
      :title="rechargeLoading && rechargeForm.payType === 1 ? '微信支付中...' : '充值余额'"
      @cancel="closeRechargeModal"
      :maskClosable="false"
      :closable="!(rechargeLoading && rechargeForm.payType === 1)"
      :footer="null"
      width="800px"
    >
      <a-form-model
        ref="rechargeForm"
        :model="rechargeForm"
        :rules="rechargeRules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }"
      >
        <a-form-model-item label="会员姓名">
          <span>{{ currentRechargeMember?.nickName || '-' }}</span>
        </a-form-model-item>
        <a-form-model-item label="手机号">
          <span>{{ currentRechargeMember?.mobile || '-' }}</span>
        </a-form-model-item>
        <a-form-model-item label="充值金额" prop="amount">
          <div style="margin-bottom: 16px">
            <a-radio-group v-model="rechargeForm.amount" button-style="solid" style="width: 100%">
              <a-row :gutter="12">
                <a-col :span="12">
                  <a-radio-button :value="50" style="width: 100%">50元</a-radio-button>
                </a-col>
                <a-col :span="12">
                  <a-radio-button :value="100" style="width: 100%">100元</a-radio-button>
                </a-col>
                <a-col :span="12" style="margin-top: 12px">
                  <a-radio-button :value="200" style="width: 100%">200元</a-radio-button>
                </a-col>
                <a-col :span="12" style="margin-top: 12px">
                  <a-radio-button :value="500" style="width: 100%">500元</a-radio-button>
                </a-col>
              </a-row>
            </a-radio-group>
          </div>
          <a-input-number
            v-model="rechargeForm.amount"
            :min="0"
            :precision="2"
            placeholder="自定义金额"
            style="width: 200px"
          />
        </a-form-model-item>
        <a-form-model-item label="赠送金额11" prop="giveAmount">
          <a-input-number
            v-model="rechargeForm.giveAmount"
            :min="0"
            :precision="2"
            placeholder="赠送金额"
            style="width: 200px"
          />
        </a-form-model-item>
        <a-form-model-item label="支付方式" prop="payType">
          <a-radio-group v-model="rechargeForm.payType">
            <a-radio :value="2">微信</a-radio>
            <a-radio :value="1">支付宝</a-radio>
            <a-radio :value="10">现金</a-radio>
            <a-radio :value="11">人民币支票</a-radio>
            <a-radio :value="12">人民币信用卡</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <!-- 微信付款码输入 -->
        <a-form-model-item v-if="rechargeForm.payType === 2" label="付款码" prop="authCode">
          <div style="margin-bottom: 8px; color: #666; font-size: 13px;">
            <a-icon type="scan" style="margin-right: 4px;" />
            请顾客打开微信「收付款」展示付款码，输入下方18位数字
          </div>
          <a-input
            ref="authCodeInput"
            v-model="rechargeForm.authCode"
            placeholder="扫描或输入微信付款码（18位数字，10-19开头）"
            size="large"
            allow-clear
          >
            <a-icon slot="prefix" type="wechat" style="color: #09bb07;" />
          </a-input>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ offset: 5, span: 19 }">
          <a-space>
            <a-button type="primary" :loading="rechargeLoading" @click="handleRecharge">
              确定充值
            </a-button>
            <a-button @click="closeRechargeModal">
              取消
            </a-button>
          </a-space>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { listMember, addMember, rechargeBalance } from '@/api/retail/member'
import { pageList as listPlusLevels, listPlusOrders } from '@/api/plus/plusLevel'
import BuyMemberModal from './BuyMemberModal'

export default {
  name: 'MemberManage',
  components: {
    BuyMemberModal
  },
  data() {
    return {
      memberList: [],
      memberPageKeyword: '',
      selectedLevel: '',
      plusLevelList: [],
      memberLoading: false,
      memberPagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      memberColumns: [
        { title: '会员姓名', dataIndex: 'nickName', width: 120, align: 'center' },
        { title: '手机号', dataIndex: 'mobile', width: 130, align: 'center' },
        { title: '会员等级', dataIndex: 'levelName', width: 100, align: 'center', scopedSlots: { customRender: 'level' } },
        { title: '真实姓名', dataIndex: 'realName', width: 120, align: 'center' },
        { title: '余额', dataIndex: 'rechargeMoney', width: 100, align: 'center', customRender: (text) => `¥${text || '0.00'}` },
        { title: '注册时间', dataIndex: 'createTime', width: 180, align: 'center' },
        { title: 'PLUS到期时间', dataIndex: 'plusExpireTime', width: 180, align: 'center' },
        { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, width: 250, align: 'center' }
      ],
      // 新增会员弹窗相关
      addMemberModalVisible: false,
      addMemberLoading: false,
      addMemberForm: {
        mobile: '',
        nickName: '',
        realName: '',
        levelId: 1
      },
      addMemberRules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        nickName: [
          { required: true, message: '请输入昵称', trigger: 'blur' }
        ]
      },
      // 购买会员弹窗相关
      buyMemberModalVisible: false,
      currentBuyMember: null,
      // PLUS会员购买记录弹窗相关
      plusOrderModalVisible: false,
      plusOrderLoading: false,
      plusOrderList: [],
      plusOrderColumns: [
        { title: '订单号', dataIndex: 'orderNo', width: 160, align: 'center' },
        { title: '会员等级', dataIndex: 'levelName', width: 100, align: 'center' },
        { title: '价格', dataIndex: 'price', width: 100, align: 'center' },
        { title: '购买时间', dataIndex: 'createTime', width: 180, align: 'center' }
      ],
      // 充值余额弹窗相关
      rechargeModalVisible: false,
      rechargeLoading: false,
      currentRechargeMember: null,
      rechargeForm: {
        amount: null,
        giveAmount: null,
        payType: null,
        authCode: ''
      },
      rechargeRules: {
        amount: [
          { required: true, message: '请输入充值金额', trigger: 'blur' },
          { type: 'number', min: 0.01, message: '充值金额必须大于0', trigger: 'blur' }
        ],
        giveAmount: [
          { type: 'number', min: 0, message: '赠送金额不能小于0', trigger: 'blur' }
        ],
        payType: [
          { required: true, message: '请选择支付方式', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.loadMemberList()
    this.loadPlusLevels()
  },
  watch: {
    // 选择微信支付时自动聚焦付款码输入框
    'rechargeForm.payType'(val) {
      if (val === 1) {
        setTimeout(() => {
          const el = this.$refs.authCodeInput
          if (el) {
            el.focus ? el.focus() : el.$el?.querySelector('input')?.focus()
          }
        }, 100)
      }
    }
  },
  methods: {
    // 显示全局支付蒙层
    showGlobalPayOverlay() {
      if (document.getElementById('global-pay-overlay')) return
      const overlay = document.createElement('div')
      overlay.id = 'global-pay-overlay'
      overlay.innerHTML = [
        '<div class="global-pay-content">',
        '  <div class="ant-spin ant-spin-lg ant-spin-spinning">',
        '    <span class="ant-spin-dot ant-spin-dot-spin">',
        '      <i class="ant-spin-dot-item"></i>',
        '      <i class="ant-spin-dot-item"></i>',
        '      <i class="ant-spin-dot-item"></i>',
        '      <i class="ant-spin-dot-item"></i>',
        '    </span>',
        '  </div>',
        '  <p class="global-pay-text">支付中，请勿刷新页面...</p>',
        '  <p class="global-pay-hint">请提醒顾客在微信中完成支付</p>',
        '</div>'
      ].join('\n')
      document.body.appendChild(overlay)
      document.body.style.overflow = 'hidden'
    },
    // 隐藏全局支付蒙层
    hideGlobalPayOverlay() {
      const overlay = document.getElementById('global-pay-overlay')
      if (overlay) {
        document.body.removeChild(overlay)
        document.body.style.overflow = ''
      }
    },
    async loadMemberList() {
      try {
        const params = {
          pageNum: this.memberPagination.current,
          pageSize: this.memberPagination.pageSize
        }
        if (this.memberPageKeyword && this.memberPageKeyword.trim()) {
          params.keyword = this.memberPageKeyword.trim()
        }
        if (this.selectedLevel) {
          params.levelId = this.selectedLevel
        }
        const response = await listMember(params)
        if (response.code == 20001 && response.data) {
          this.memberList = response.data.records || []
          this.memberPagination.total = response.data.total || 0
        }
      } catch (error) {
        this.$message.error('加载会员列表失败')
      }
    },
    // 加载PLUS会员等级列表
    async loadPlusLevels() {
      try {
        const response = await listPlusLevels({
          pageNum: 1,
          pageSize: 100,
          status: 1
        })
        if (response.code == 20001 && response.data) {
          this.plusLevelList = response.data.records || []
        }
      } catch (error) {
        console.error('加载会员等级列表失败', error)
      }
    },
    // 会员管理页面搜索会员
    async handleMemberPageSearch() {
      this.memberPagination.current = 1
      await this.loadMemberList()
    },
    handleMemberTableChange(pagination) {
      this.memberPagination = { ...this.memberPagination, ...pagination }
      this.loadMemberList()
    },
    // 会员等级颜色映射(动态返回颜色)
    getMemberLevelColor(levelName) {
      // 根据等级名称动态生成颜色
      const colorMap = {
        '普通会员': 'blue',
        'VIP会员': 'gold',
        '白银会员': 'cyan',
        '黄金会员': 'orange',
        '铂金会员': 'purple',
        '钻石会员': 'red'
      }
      // 如果在映射中找到,返回对应颜色,否则根据等级名称生成hash颜色
      if (colorMap[levelName]) {
        return colorMap[levelName]
      }
      // 根据等级名称生成固定的颜色
      const colors = ['blue', 'green', 'cyan', 'orange', 'red', 'purple', 'pink', 'magenta']
      const hash = levelName.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)
      return colors[hash % colors.length] || 'default'
    },
    // 打开新增会员弹窗
    openAddMemberModal() {
      this.addMemberForm = {
        mobile: '',
        nickName: '',
        realName: '',
        levelId: 1
      }
      this.addMemberModalVisible = true
      this.$nextTick(() => {
        this.$refs.addMemberForm.clearValidate()
      })
    },
    // 关闭新增会员弹窗
    closeAddMemberModal() {
      this.addMemberModalVisible = false
      this.addMemberForm = {
        mobile: '',
        nickName: '',
        realName: '',
        levelId: 1
      }
    },
    // 新增会员
    async handleAddMember() {
      try {
        await this.$refs.addMemberForm.validate()
        this.addMemberLoading = true
        const response = await addMember(this.addMemberForm)
        if (response.code == 20001) {
          this.$message.success('新增会员成功')
          this.closeAddMemberModal()
          this.loadMemberList()
        } else {
          this.$message.error(response.msg || '新增会员失败')
        }
      } catch (error) {
        if (error.errorFields) {
          // 表单验证错误
          return
        }
        this.$message.error('新增会员失败，请重试')
      } finally {
        this.addMemberLoading = false
      }
    },
    // 打开购买会员弹窗
    openBuyMemberModal(record) {
      this.currentBuyMember = record
      this.buyMemberModalVisible = true
    },
    // 关闭购买会员弹窗
    closeBuyMemberModal() {
      this.buyMemberModalVisible = false
      this.currentBuyMember = null
    },
    // 购买会员成功回调
    handleBuyMemberSuccess() {
      this.buyMemberModalVisible = false
      this.currentBuyMember = null
      this.loadMemberList()
    },
    // 打开PLUS会员购买记录弹窗
    async openPlusOrderModal(record) {
      this.currentBuyMember = record
      this.plusOrderModalVisible = true
      await this.loadPlusOrderList(record.id)
    },
    // 关闭PLUS会员购买记录弹窗
    closePlusOrderModal() {
      this.plusOrderModalVisible = false
      this.plusOrderList = []
      this.currentBuyMember = null
    },
    // 加载PLUS会员购买记录
    async loadPlusOrderList(userId) {
      try {
        this.plusOrderLoading = true
        const response = await listPlusOrders({ userId })
        if (response.code == 20001 && response.data) {
          this.plusOrderList = response.data.records || response.data || []
        }
      } catch (error) {
        this.$message.error('加载购买记录失败')
      } finally {
        this.plusOrderLoading = false
      }
    },
    // 获取订单状态颜色
    getOrderStatusColor(status) {
      const colorMap = {
        0: 'default',  // 待支付
        1: 'green',   // 已支付
        2: 'red',     // 已取消
        3: 'orange'   // 已退款
      }
      return colorMap[status] || 'default'
    },
    // 获取订单状态文本
    getOrderStatusText(status) {
      const textMap = {
        0: '待支付',
        1: '已支付',
        2: '已取消',
        3: '已退款'
      }
      return textMap[status] || '未知'
    },
    // 获取支付方式文本
    getPayTypeText(payType) {
      const textMap = {
        '2': '微信',
        '1': '支付宝',
        '10': '现金'
      }
      return textMap[payType] || '-'
    },
    // 打开充值余额弹窗
    openRechargeModal(record) {
      this.currentRechargeMember = record
      this.rechargeForm = {
        amount: null,
        giveAmount: null,
        payType: 1
      }
      this.rechargeModalVisible = true
      this.$nextTick(() => {
        this.$refs.rechargeForm?.clearValidate()
      })
    },
    // 关闭充值余额弹窗
    closeRechargeModal() {
      this.rechargeModalVisible = false
      this.rechargeForm = {
        amount: null,
        giveAmount: null,
        payType: 1,
        authCode: ''
      }
      this.currentRechargeMember = null
    },
    // 充值余额
    async handleRecharge() {
      try {
        await this.$refs.rechargeForm.validate()

        // 验证微信付款码
        if (this.rechargeForm.payType === 1) {
          if (!this.rechargeForm.authCode || this.rechargeForm.authCode.trim() === '') {
            this.$message.warning('微信支付需要输入付款码')
            return
          }
          if (!/^1[0-9]{17}$/.test(this.rechargeForm.authCode.trim())) {
            this.$message.warning('付款码格式不正确，应为18位数字（10-19开头）')
            return
          }
        }

        // 微信支付显示全局蒙层
        if (this.rechargeForm.payType === 1) this.showGlobalPayOverlay()
        this.rechargeLoading = true
        const data = {
          userId: this.currentRechargeMember.id,
          rechargeMoneyMoney: this.rechargeForm.amount,
          giveAmount: this.rechargeForm.giveAmount || 0,
          payType: this.rechargeForm.payType,
          authCode: this.rechargeForm.payType === 1 ? this.rechargeForm.authCode.trim() : undefined
        }
        const response = await rechargeBalance(data)
        if (response.code == 20001) {
          this.$message.success('充值成功')
          this.closeRechargeModal()
          this.loadMemberList()
        } else {
          this.$message.error(response.msg || '充值失败')
        }
      } catch (error) {
        if (error.errorFields) {
          return
        }
        const errMsg = error?.response?.data?.msg || error?.response?.data?.message || error?.message || '充值失败，请重试'
        this.$message.error(errMsg)
      } finally {
        this.rechargeLoading = false
        if (this.rechargeForm.payType === 1) this.hideGlobalPayOverlay()
      }
    }
  }
}
</script>

<style scoped lang="less">
.member-manage-section {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: #f0f2f5;

  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }
  }

  .search-bar {
    margin-bottom: 16px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
  }

}
</style>
